import { MaybePromise } from 'component_utils/utils';
import { OnEnterArgs, State } from '..';

interface EventProps {}

interface Config<S, P, A, R> {
  nextState: number;
  getValues: (args: OnEnterArgs<S, P, R>) => MaybePromise<Partial<S>>;
}

const StateSet = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  getValues,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      const data = await getValues(args);
      return {
        data,
        type: 'MOVE',
        nextState: nextState,
      };
    },

    nodeName: 'T.states.set',
    outputs: [
      {
        name: 'after',
        to: nextState,
      },
    ],
  };
};

export default StateSet;
